<ion-content>
  <div class="modal-container">
    <div class="modal-content">
      <div class="order-payment-title">{{ "PAY_ONLINE" | translate }}</div>

      <app-payment
        [savedCards]="orderPaymentOptions.savedCards"
        [availablePaymentClients]="orderPaymentOptions.paymentOptions"
      ></app-payment>

      <div class="footer">
        <ion-row>
          <ion-col class="ion-no-padding">
            <ion-button expand="block" color="grey" class="custom-button" (click)="onCancel()">
              {{ "CANCEL" | translate }}
            </ion-button>
          </ion-col>
          <ion-col class="ion-no-padding">
            <ion-button color="green" expand="block" class="custom-button" (click)="onPay()">
              <ng-container>{{ "PAY_AMOUNT" | translate : { amount: orderPaymentOptions.totalDue | localCurrency } }}</ng-container>
            </ion-button>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>
</ion-content>
